import Box from "@mui/material/Box";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";

import { FS } from "@plannel/utils/font-util";

export const PRIORITY_NORMAL = "NORMAL";
export const PRIORITY_URGENT = "URGENT";

/**
 * 급한 안건 배지. 긴급도 색의 <b>단일 소스</b>다.
 *
 * <p><b>두 단계뿐이고, 보통 안건에는 아무것도 그리지 않는다.</b> 가운데 값을 두면 사람들이
 * 거기로 몰려 구분이 사라지고, 모든 줄에 칩이 달리면 그 칩은 아무 뜻도 갖지 못한다. 그래서
 * {@code NORMAL} 이면 {@code null} 을 돌려준다 — 부르는 쪽에서 조건을 쓰지 않아도 된다.
 *
 * <p>회의 시간이 이미 급한 정도를 말해 주므로, 이 배지는 한 가지 뜻만 진다 —
 * <b>회의 전에 미리 봐 두어야 한다</b>.
 */
const AgendaPriorityChip = ({ priorityCd, t }) => {
  if (priorityCd !== PRIORITY_URGENT) {
    return null;
  }
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.125,
        fontSize: FS.CAPTION,
        fontWeight: 700,
        letterSpacing: "0.03em",
        textTransform: "uppercase",
        color: "#A81F1F",
        bgcolor: "#FDECEC",
        borderRadius: 1,
        pl: 0.25,
        pr: 0.75,
        py: 0.375,
        whiteSpace: "nowrap"
      }}
    >
      <PriorityHighIcon sx={{ fontSize: 13 }} />
      {t("meetingAgendaPriorityUrgent")}
    </Box>
  );
};

export default AgendaPriorityChip;
